import { AppNavBar } from "design-system/AppShell";
import { usePage } from "contexts/PageContext";
import { useAppUI } from "contexts/UIContext";

import logo from "../../../assets/images/westernbulk_logo_white.png";

/**
 * Top-level NavBar for the Western Ava app frame. Composes the
 * design-system `<AppNavBar>` with the project's brand mark, page
 * navigation context, and sidebar-toggle wiring.
 *
 * Provenance — `<AppNavBar>` is skill-derived (not from the Claude
 * Design bundle) and the wiring here is project-specific.
 */
function Navbar() {
  const { navigate } = usePage();
  const { toggleSidebar, sidebarOpen } = useAppUI();

  return (
    <AppNavBar
      brand={<img src={logo} alt="Western Bulk" />}
      onBrandClick={() => navigate("")}
      onMenuToggle={toggleSidebar}
      menuOpen={sidebarOpen}
    />
  );
}

export default Navbar;
